import { TELUGU } from './language/telugu';
import { ENGLISH } from './language/english';
import { HINDI } from './language/hindi';
import { TAMIL } from './language/tamil';

export const FORM_TEXTS = {
  English: ENGLISH,
  Hindi: HINDI,
  Telugu: TELUGU,
  Tamil: TAMIL
};
